module.exports = __webpack_public_path__ + "2da5c5ebf4b619cdc5102eb3a138dc31.svg";